"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.plusOneComponent = exports.PlusOneComponent = void 0;
const app_1 = require("app");
const PlusOneForm_1 = require("Views/Partials/Components/PlusOneForm");
const types_1 = require("Views/Partials/Components/PlusOneForm/types");
const PlusOneSupportFormConfig_1 = require("./PlusOneSupportFormConfig");
class PlusOneComponent extends app_1.Component {
    constructor() {
        super(...arguments);
        this.selector = '.plus-one-form';
        this.convertData = (inputLabels, errorInputMessage, hint) => {
            const convertedData = [];
            Object.keys(inputLabels).map(input => convertedData.push(Object.assign(Object.assign({}, PlusOneSupportFormConfig_1.inputData[input]), { label: inputLabels[input], errorMessage: errorInputMessage, hint, width: PlusOneSupportFormConfig_1.inputData[input].width })));
            return convertedData;
        };
    }
    OnInit() {
        this.el.forEach(el => {
            this.InitForm(el);
        });
    }
    InitForm(selector) {
        const title = app_1.AttrService.data(selector, 'title');
        const apiUrl = app_1.AttrService.data(selector, 'post-url');
        const pageId = app_1.AttrService.data(selector, 'page');
        const control = app_1.AttrService.data(selector, 'control');
        const formType = app_1.AttrService.data(selector, 'form-type');
        const culture = app_1.AttrService.data(selector, 'culture');
        const reCaptchaSiteKey = app_1.AttrService.data(selector, 'recaptcha-key');
        const successMessageTitle = app_1.AttrService.data(selector, 'success-message-title');
        const successMessage = app_1.AttrService.data(selector, 'success-message');
        const errorMessage = app_1.AttrService.data(selector, 'error-message');
        const userConsentText = app_1.AttrService.data(selector, 'user-consent-text');
        const userConsentValidationText = app_1.AttrService.data(selector, 'user-consent-validation-message');
        const userConsentUrlAndText = app_1.AttrService.data(selector, 'user-consent-url-message');
        const attachmentInfo = app_1.AttrService.data(selector, 'attachment-info');
        const instructionSubmit = app_1.AttrService.data(selector, 'instruction-submit');
        const instructionMandatory = app_1.AttrService.data(selector, 'instruction-mandatory');
        const instructionEmail = app_1.AttrService.data(selector, 'instruction-email');
        const hint = app_1.AttrService.data(selector, 'input-hint-message');
        const errorInputMessage = app_1.AttrService.data(selector, 'input-validation-message');
        const inputFileErrorMessage = app_1.AttrService.data(selector, 'input-file-validation-message');
        const emailLabel = app_1.AttrService.data(selector, 'email-label');
        const productLabel = app_1.AttrService.data(selector, 'product-label');
        const eidLabel = app_1.AttrService.data(selector, 'eid-label');
        const subjectLabel = app_1.AttrService.data(selector, 'subject-label');
        const descriptionLabel = app_1.AttrService.data(selector, 'description-label');
        const bypassRecaptchaKey = app_1.AttrService.data(selector, 'bypass-recaptcha-key');
        const inputLabelsLeft = {
            [types_1.InputName.EMAIL]: emailLabel,
            [types_1.InputName.PRODUCT]: productLabel,
            [types_1.InputName.EID]: eidLabel,
        };
        const inputLabelsRight = {
            [types_1.InputName.SUBJECT]: subjectLabel,
            [types_1.InputName.DESCRIPTION]: descriptionLabel,
            [types_1.InputName.CHECKBOX]: userConsentUrlAndText,
        };
        const formItemsLeft = this.convertData(inputLabelsLeft, errorInputMessage, hint);
        const formItemsRight = this.convertData(inputLabelsRight, errorInputMessage, hint);
        const formMessages = {
            successMessageTitle,
            successMessage,
            errorMessage,
            userConsentText,
            userConsentValidationText,
            attachmentInfo,
            inputFileErrorMessage,
            instructionSubmit,
            instructionMandatory,
            instructionEmail,
        };
        (0, PlusOneForm_1.RenderPlusOneForm)({
            selector,
            apiUrl,
            pageId,
            control,
            formType,
            culture,
            reCaptchaSiteKey,
            formItemsLeft,
            formItemsRight,
            formMessages,
            title,
            bypassRecaptchaKey,
        });
    }
}
exports.PlusOneComponent = PlusOneComponent;
exports.plusOneComponent = new PlusOneComponent();
